import { isSameHorse } from './primary.js'

export const isArchivedHorse = (horse) => Boolean(horse?.archived_at)

/**
 * The horses offered to start something new (event, session, recording, program):
 * an archived horse keeps its history but is never proposed again, except the
 * horse an item already has, so editing that item still shows it. Keeps the
 * source order and passes a list not loaded yet through.
 */
export const activeHorsesOf = (horses, keptHorseId = null) => {
    if (!Array.isArray(horses)) return horses

    return horses.filter((horse) => !isArchivedHorse(horse) || isSameHorse(horse, keptHorseId))
}

/**
 * Keeps an item's own horse among the options it is edited with, even when that
 * horse is archived and so no longer offered: appended once, never duplicated, and
 * a horse without an id is never added. Never mutates the options.
 */
export const withKeptHorse = (options, keptHorse) => {
    const keptHorseId = keptHorse?.id
    if (!Array.isArray(options) || keptHorseId === null || keptHorseId === undefined) return options
    if (options.some((horse) => isSameHorse(horse, keptHorseId))) return options

    return [...options, keptHorse]
}
